/**
 * Minimal slugify used to live-preview admin URLs.
 * Mirrors the behaviour of python's `python-slugify` for ASCII inputs:
 *   - lowercase
 *   - strip diacritics
 *   - replace any non-alphanumeric run with a single hyphen
 *   - trim hyphens at the edges
 */
export function slugify(input) {
  if (!input) return "";
  return String(input)
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "") // strip diacritics
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
